import { specialtiesSlice } from './slice'
import axios from 'axios'
import { API_INTERFACE } from '../../../services/constants'
const providerDomainApi = axios.create({ baseURL: process.env.CAREPOINT_URL || process.env.REACT_APP_CAREPOINT_URL });
const { setSpecialties, loadSpecialties } = specialtiesSlice.actions

export const fetchSpecialties = () => async (dispatch: any) => {
  dispatch(loadSpecialties())  
  const response = await providerDomainApi.get(API_INTERFACE.GET_SPECIALTY_LIST, { params: { isProvider: true } })
  const sortedData = response.data.sort((a: any, b: any) =>
    a.specialty === b.specialty ? 0 : a.specialty < b.specialty ? -1 : 1
  )

  dispatch(setSpecialties(sortedData))
}
